/* *********************************************************************************************************** */
/* *********************************************************************************************************** */

// Skill category
export const categories = [
  {
    id: "responsibility",
    displayName: "Responsibilities",
    show: true,
    sortOrder: 0,
  },
  {
    id: "backend",
    displayName: "Backend",
    show: true,
    sortOrder: 1,
  },
  {
    id: "frontend",
    displayName: "Frontend",
    show: true,
    sortOrder: 2,
  },
  {
    id: "devops",
    displayName: "DevOps",
    show: true,
    sortOrder: 3,
  },
  {
    id: "others",
    displayName: "Others",
    show: true,
    sortOrder: 4,
  },
];
const RESPONSIBILITY = categories?.find((s) => s.id === "responsibility");
const FRONTEND = categories?.find((s) => s.id === "frontend");
const BACKEND = categories?.find((s) => s.id === "backend");
const DEVOPS = categories?.find((s) => s.id === "devops");
const OTHERS = categories?.find((s) => s.id === "others");

export const experienceList = [
  {
    companyName: "M1xchange",
    employmentType: "Full-Time",
    startDate: "Jul 2026",
    endDate: "Present",
    location: "Remote, Bengaluru",
    companyType: "Product-based",
    companyWebsite: "https://m1xchange.com/",
    companyIntro:
      "M1xchange TReDS is a digital marketplace to sell the receivables to banks/NBFC set up under the approval of Reserve Bank of India (RBI) to facilitate the discounting of invoices and bills of exchange on a PAN India basis.",
    positions: [
      {
        title: "Senior Software Engineer",
        startDate: "Jul 2026",
        endDate: "Present",
        isCurrent: true,
        description: [
          {
            bulletPoint: `Building a WhatsApp-integrated conversational agent on Meta’s WhatsApp Cloud API, using FastAPI for the webhook layer and LangGraph to orchestrate conversation state, architected for omnichannel extensibility across future channels like Outlook and IVR.`,
            category: BACKEND,
          },
        ],
      },
    ],
  },
  {
    companyName: "C2FO (acquired by M1xchange)",
    employmentType: "Full-Time",
    startDate: "Sep 2023",
    endDate: "June 2026",
    location: "Remote, Bengaluru",
    companyType: "Product-based",
    companyWebsite: "https://c2treds.com/",
    companyIntro:
      "A FinTech organization revolutionizing MSME financing in India by converting invoices into immediate working capital through a unified TReDS platform connecting suppliers, buyers, and financiers.",
    positions: [
      {
        title: "Senior Software Engineer I",
        startDate: "Mar 2026",
        endDate: "June 2026",
        isCurrent: false,
        description: [
          {
            bulletPoint:
              "Automated invoice intake from a government procurement platform, replacing manual upload workflows.",
            category: BACKEND,
          },
          {
            bulletPoint:
              "Scaled invoice ingestion capacity from 10K to 100K invoices per file using batching and checkpointing.",
            category: BACKEND,
          },
          {
            bulletPoint:
              "Strengthened platform security and compliance across authentication, APIs, and backend services.",
            category: BACKEND,
          },
          {
            bulletPoint: "Mentored engineers through code reviews and architectural guidance.",
            category: BACKEND,
          },
          {
            bulletPoint:
              "Built a reconciliation microservice using ACID transactions and event-driven workflows with Amazon SQS.",
            category: BACKEND,
          },
        ],
      },
      {
        title: "Software Engineer II",
        startDate: "Sep 2023",
        endDate: "Feb 2026",
        description: [
          // {
          //   bulletPoint: "Responsible for",
          //   category: RESPONSIBILITY,
          // },
          {
            bulletPoint:
              "Reduced API latency by up to 90% through caching and database optimizations.",
            category: BACKEND,
          },
          {
            bulletPoint:
              "Designed APIs, database schemas, and event-driven integrations for invoice discounting workflows.",
            category: BACKEND,
          },
          {
            bulletPoint:
              "Developed responsive front-end interfaces using Next.js and GraphQL for financial dashboards and admin tools.",
            category: FRONTEND,
          },
        ],
      },
    ],
  },
  {
    companyName: "Nference",
    employmentType: "Full-Time",
    startDate: "Jan 2021",
    endDate: "Aug 2023",
    location: "Bengaluru, India",
    companyType: "Product-based",
    companyWebsite: "https://www.pramana.ai/",
    companyIntro:
      "A HealthTech organization offering modular digital pathology scanners that seamlessly scale with lab needs, turning optical precision into faster diagnostics and discovery.",
    positions: [
      {
        title: "Senior Engineer",
        duration: "Apr 2022 - Aug 2023",
        startDate: "Apr 2022",
        endDate: "Aug 2023",
        description: [
          {
            bulletPoint: `Driven small projects to re-architect the system's components improving its robustness and resilience.`,
            category: BACKEND,
          },
          {
            bulletPoint: `Redesigned the architecture of the node server to improve code maintainability and reduce issues, ultimately minimizing the resources required for development and testing.`,
            category: BACKEND,
          },
          {
            bulletPoint: `Upgraded inter-service communication by implementing a RabbitMQ-based message queue to enhance the system's availability and fault tolerance, which resulted in a 50% reduction in errors.`,
            category: BACKEND,
          },
          {
            bulletPoint: `Collaborated with the DevOps team to deploy applications to the cloud, utilizing HAProxy and Nginx servers.`,
            category: DEVOPS,
          },
          {
            bulletPoint: `Performed code reviews, implemented best practices, and enforced coding standards to ensure high-quality code and maintainable systems.`,
            category: OTHERS,
          },
        ],
      },
      {
        title: "Software Engineer",
        startDate: "Jan 2021",
        endDate: "Mar 2022",
        description: [
          {
            bulletPoint: `Played a significant role in helping the company secure a 10 million dollar long-term contract by developing robust APIs and user-friendly UI screens.`,
            category: BACKEND,
          },
          {
            bulletPoint: `Integrated Kafka to facilitate real-time data synchronization across multiple applications.`,
            category: BACKEND,
          },
          {
            bulletPoint: `Achieved a 75% reduction in deployment time by implementing a seamless deployment method of the applications in multiple modes and environments.`,
            category: DEVOPS,
          },
          {
            bulletPoint: `Developed an efficient Node.js-based load balancer to manage parallel processing across multiple machines, resulting in the successful conversion of 25K DZI images into DICOM format.`,
            category: BACKEND,
          },
          {
            bulletPoint: `Received the "Ngenious Award" in recognition of my outstanding performance.`,
            category: OTHERS,
          },
          {
            bulletPoint: `Employed best coding practices to thoughtfully design, test, and implement new features that effectively address issues and drive software forward.`,
            category: FRONTEND,
          },
          {
            bulletPoint: `Developed cross-platform compatible desktop application to view DZI (Deep Zoom Image) using electron builder.`,
            category: FRONTEND,
          },
        ],
      },
    ],
  },
  {
    companyName: "Piktorlabs",
    employmentType: "Full-Time",
    startDate: "Jul 2019",
    endDate: "Jan 2021",
    location: "Bengaluru, India",
    companyType: "Product-based",
    companyWebsite: "https://piktorlabs.com/",
    companyIntro: "",
    positions: [
      {
        title: "Software Engineer",
        startDate: "Jul 2019",
        endDate: "Jan 2021",
        description: [
          {
            bulletPoint: `Transformed Express API Server hosted on AWS elastic beanstalk into Serverless APIs using Node.js and AWS Lambda entirely from scratch, which led to a decrease in server downtime.`,
            category: BACKEND,
          },
          {
            bulletPoint: `Played a key role in the integration of the ADP APIs and launch GoTag, an employee portal application, on the ADP Marketplace.`,
            category: BACKEND,
          },
          {
            bulletPoint: `Throughout my tenure at this company, I worked on several projects and gained experience in utilizing a diverse range of technologies such as React.js, Redux, Node.js, MongoDB, Vue.js, Python, React Native, and AWS.`,
            category: FRONTEND,
          },
        ],
      },
    ],
  },
];

export const companyExperiences = [
  {
    companyNo: 1,
    companyName: "Piktorlabs",
    startDate: "2019-07-15",
    endDate: "2021-01-15",
  },
  {
    companyNo: 2,
    companyName: "Nference",
    startDate: "2021-01-18",
    endDate: "2023-09-01",
  },
  {
    companyNo: 3,
    companyName: "C2FO",
    startDate: "2023-09-03",
    endDate: "Present",
  },
];
